import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Manufacturer } from '../../models/manufacturer.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';

@Injectable({
  providedIn: 'root',
})
export class ManufacturersService {
  
  gnBaseURL: any;
  constructor(private http: HttpClient,private appURL: AppConfigService) {
    this.gnBaseURL=this.appURL.getServerUrl(); 
  }

  getAllManufacturers(): Observable<Manufacturer[]> {
    return this.http.get<Manufacturer[]>(this.gnBaseURL + 'Manufacturer/GetManufacturerList');
  }

  addManufacturer(
    addManufacturerRequest: Manufacturer
  ): Observable<Manufacturer> {
   
    return this.http.post<Manufacturer>(
      this.gnBaseURL + 'Manufacturer/AddManufacturer',
      addManufacturerRequest
    );
  }

  getManufacturer(id: string): Observable<Manufacturer> {
    return this.http.get<Manufacturer>(this.gnBaseURL + 'Manufacturer/GetManufacturerById/' + id);
  }

  updateManufacturer(
    id: number,
    updateManufacturerRequest: Manufacturer
  ): Observable<Manufacturer> {
    return this.http.post<Manufacturer>(
      this.gnBaseURL + 'Manufacturer/EditManufacturer/' + id,
      updateManufacturerRequest
    );
  }

  deleteManufacturer(id: number): Observable<Manufacturer> {
    return this.http.delete<Manufacturer>(this.gnBaseURL + 'Manufacturer/' + id);
  }
}
